export default __webpack_public_path__ + "static/media/gallery_05.3f85d735.jpg";